module.exports = __webpack_public_path__ + "static/img/logo.06f082a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 100
// module chunks = 2